/**
 * サンプルクラス
 * @constructor
 */
class TopTab {

  constructor() {
    this.activeClass = 'is-active';
    this.selectedClass = 'is-selected';
    this.init();
  }

  /**
  * 初期化メソッド
  * ページ内に指定された要素（.js-topTab）が存在する場合実行する
  */
init() {
  if (document.querySelector('.js-topTab')) {
    this.topTab();
  }
}
topTab() {
  const tab = document.querySelector('.p-topNewsRelease__tab');
  const tabItems = document.querySelectorAll('.js-topTab');
  const contentBoxes = document.querySelectorAll('.p-topNewsRelease__newsContents > div');
  const contentLink = document.querySelectorAll('.p-topNewsRelease__linkItem');
  const contentLinkTag = document.querySelector('.p-topNewsRelease__linkTag');
  const linkAddress = ['news','magazine'];

  tabItems.forEach((tabItem, index) => {
    tabItem.addEventListener('click', () => {
      if (!tabItem.classList.contains('is-active')) {

        // ボタンのリンク先の変更
        contentLinkTag.setAttribute('href', `/${linkAddress[index]}/`);

        // 選択されたタブによるニュースの表示切り替え
        contentBoxes.forEach((box, boxIndex) => this.classChange(box, boxIndex, index));
        // タブの切り替えによって、「一覧を見る」の文言を変更する
        contentLink.forEach((box, boxIndex) => this.classChange(box, boxIndex, index));
        // 他のタブの選択状態をリセット
        tabItems.forEach((item, itemIndex) => {
          this.classChange(item, itemIndex, index);
        });
        (index === 1) ? tab.classList.toggle(this.selectedClass) : tab.classList.toggle(this.selectedClass);
      }
    });
  });
}
classChange(elem, elemIndex, tabIndex) {
  (elemIndex === tabIndex) ? elem.classList.toggle(this.activeClass) : elem.classList.toggle(this.activeClass);
}
}

export default TopTab;
